import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Penalty from "./tabs/Penalty";
import { Wrapper } from "../styled";

const penaltiesTabs = [
{
    title: "Взыскания",
    component: <Penalty/>,
}
];

const Penalties: FC = () => {
const [tab, setTab] = useState(0);

const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
};

return (
    <Wrapper>
    <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
    >
        {penaltiesTabs.map((tab) => (
        <Tab key={tab.title} label={tab.title} />
        ))}
    </Tabs>
    {penaltiesTabs[tab].component}
    </Wrapper>
);
};

export default Penalties;
